import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="https://customer-assets.emergentagent.com/job_jd-mailer-pro/artifacts/25t7dqsa_Untitled%20design%20%2835%29.png" alt="Aplica" className="h-8 w-8 rounded-md" />
            <span className="font-display font-semibold text-lg">Aplica</span>
          </Link>
          <Link to="/" className="text-sm text-slate-600 hover:text-slate-900 inline-flex items-center gap-1.5">
            <ArrowLeft className="h-4 w-4" /> Back home
          </Link>
        </div>
      </header>
      <article className="max-w-3xl mx-auto px-6 py-16">
        <span className="label-xs">Legal</span>
        <h1 className="mt-2 text-4xl md:text-5xl font-display tracking-tighter">Privacy Policy</h1>
        <p className="mt-3 text-slate-500">Effective Date: 10 Apr, 2026</p>

        <div className="mt-10 prose prose-slate max-w-none space-y-8 text-slate-700 leading-relaxed">
          <p>Welcome to <strong>Aplica</strong> ("we," "our," or "us"). Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our platform.</p>

          <Section title="1. Information We Collect">
            <h4 className="font-display font-medium text-slate-900 mt-4">a. Personal Information</h4>
            <ul className="list-disc pl-6 mt-1 space-y-1"><li>Name</li><li>Email address</li><li>Account credentials</li><li>Portfolio links (Google Drive, Dropbox, etc.)</li></ul>
            <h4 className="font-display font-medium text-slate-900 mt-4">b. Usage Data</h4>
            <ul className="list-disc pl-6 mt-1 space-y-1"><li>Job descriptions entered</li><li>Generated emails</li><li>App usage behavior (analytics)</li></ul>
            <h4 className="font-display font-medium text-slate-900 mt-4">c. Third-Party Data</h4>
            <ul className="list-disc pl-6 mt-1 space-y-1"><li>Google account data (if you use Gmail integration)</li></ul>
          </Section>

          <Section title="2. How We Use Your Information">
            <ul className="list-disc pl-6 space-y-1">
              <li>Generate personalized job application emails</li>
              <li>Send emails via your connected account</li>
              <li>Improve our services and user experience</li>
              <li>Provide support and communicate with you</li>
            </ul>
          </Section>

          <Section title="3. Email & Account Integration">
            <p>Aplica uses Gmail API (or similar services) to send emails on your behalf.</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>We do <strong>NOT</strong> read, store, or share your email content unnecessarily.</li>
              <li>We only access what is required to send emails you initiate.</li>
            </ul>
          </Section>

          <Section title="4. Data Storage">
            <ul className="list-disc pl-6 space-y-1">
              <li>Portfolio files are NOT stored (only links are used)</li>
              <li>Basic account data is stored securely in our database</li>
              <li>We take reasonable steps to protect your data</li>
            </ul>
          </Section>

          <Section title="5. Data Sharing">
            <p>We do <strong>NOT</strong> sell your data.</p>
            <p className="mt-2">We may share data with:</p>
            <ul className="list-disc pl-6 mt-1 space-y-1"><li>Service providers (hosting, analytics)</li><li>Legal authorities if required by law</li></ul>
          </Section>

          <Section title="6. Your Rights">
            <ul className="list-disc pl-6 space-y-1"><li>Access your data</li><li>Request deletion of your account</li><li>Disconnect integrations anytime</li></ul>
          </Section>

          <Section title="7. Security">
            <p>We implement industry-standard security practices, but no system is 100% secure.</p>
          </Section>

          <Section title="8. Changes to This Policy">
            <p>We may update this policy. Continued use of Aplica means you accept updates.</p>
          </Section>

          <Section title="9. Contact Us">
            <p className="inline-flex items-center gap-2"><Mail className="h-4 w-4" /> <a href="mailto:aplica1410@gmail.com" className="text-[#0047FF] hover:underline">aplica1410@gmail.com</a></p>
          </Section>
        </div>
      </article>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="text-2xl font-display tracking-tight text-slate-900 mb-3">{title}</h2>
      <div className="text-slate-600">{children}</div>
    </section>
  );
}
